import React from 'react';
import PageLayout from '../../../global/partialBase/pageLayout';
import OrderDetailsBody from './body';

const OrderDetails = () => {
    return (
        <div>
            <PageLayout tabMenu={false} body={<OrderDetailsBody />} />
        </div>
    )
}

export default OrderDetails;